import footer from "./footer";
import zxqyFooter from "./zxqyFooter";

export default [footer, zxqyFooter];
